import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import App from './App';
import CompanionPortal from './components/companion/CompanionPortal';
import { isCompanionPortalPath } from './config/companionPortal';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// The companion portal swaps in at the root instead of mounting inside App, so
// end users never load the admin shell, its navigation or its entitlement calls.
const Root = isCompanionPortalPath(window.location.pathname) ? CompanionPortal : App;

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <Root />
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
